import utf8 from 'utf8'
import base64 from 'base-64'
import { companyAvatar, userAvatar } from 'Services/avatarGenerator'
import { ApiAccessLoginResult, AccessLoginResult } from 'Types'
import verificationTypeTwoFactorAuth from 'Enums/verificationTypeTwoFactorAuth'

const decode = value => utf8.decode(base64.decode(value))
const parseId = value => isNaN(parseInt(value)) ? null : parseInt(value)

export const parseEncodedAuth = (encodedList: string[]): AccessLoginResult => {
  const authList = encodedList.map(decode)
  const isAuthorized = (authList[0] === 'True')
  return {
    token: authList[1],
    id: isAuthorized ? parseId(authList[2]) : null,
    name: authList[3],
    email: authList[4],
    avatar: isAuthorized ? userAvatar(authList[5], name) : '',
    companyId: isAuthorized ? parseId(authList[6]) : null,
    companyName: authList[7],
    companyLogo: isAuthorized ? companyAvatar(authList[8], authList[7]) : '',
    isFirstAccess: false,
    rate: authList[9],
    companyRate: authList[10],
    isTwoFactorAuthenticationEnabled: (authList[11] !== 'False'),
    waitingRegistration: (authList[11] !== 'False'),
    userAuthenticatedRole: isAuthorized? authList[12] : '',
  }
}

export const parseApiAuth = (data: ApiAccessLoginResult): AccessLoginResult => {
  return {
    id: data.id,
    token: data.token,
    name: data.name,
    email: data.email,
    avatar: userAvatar(data.imageSmallPath, data.name),
    companyId: data.companyId,
    companyName: data.companyName,
    companyLogo: companyAvatar(data.companyLogo, data.companyName),
    isFirstAccess: data.firstAccess || false,
    rate: data.rate,
    companyRate: data.companyRate,
    isTwoFactorAuthenticationEnabled: data.twoFactorEnable,
    waitingRegistration: data.waitingRegistration,
    userAuthenticatedRole: data.userAuthenticatedRole
  }
}

export const parseTwoFactorAuthStatus = (data) => {
  return {
    status: data.status,
  }
}

export const parseSelectedOptionTwoFactorAuth = selectedOption => {

    const verificationType = verificationTypeTwoFactorAuth.toList('value', 'name');

    switch (selectedOption) {
      case verificationType[verificationTypeTwoFactorAuth.whatsapp].name:
        return 1;
      case verificationType[verificationTypeTwoFactorAuth.sms].name:
        return 2;
      case verificationType[verificationTypeTwoFactorAuth.email].name:
        return 3;
      default:
        return 0
    }

}

export default {
  parseEncodedAuth,
  parseApiAuth,
  parseTwoFactorAuthStatus,
  parseSelectedOptionTwoFactorAuth
}